function prediction_afternoon_rain(){
	var list_option_html = '', todayIndex, stationIdList = {"466900": "淡水", "466920": "臺北", "466940": "基隆"}, timeList = ["08","09","10","11"]
	for (var index = 0; index < 7; index++) {
		var thisTime = get_time_string(index * 24).slice(0,10)
		if (index == 0) { todayIndex =  thisTime }
		list_option_html += `<option value="${thisTime}">${thisTime}</option>`
	}
	$("#prediction_afternoon_rain").html(
		'<h5 class="font-weight-bold mb-0"><i class="fas fa-info-circle mr-2"></i>午後雷陣雨預測功能說明</h5>'+
		'<h6 class="text-justify mt-1">為介接國家災害防救科技中心所提供的新北市午後雷陣雨監測模組(WATCH)，於每日上午8時至11時期間，透過研判相關氣象參數，包含水氣壓、濕度、風向與風速等，預測當日下午是否會發生午後雷陣雨，最後可彙整各行政區實際下午降雨結果，並與上午預測結果進行比較。</h6>'+
		'<div class="input-group mt-2">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">選擇預報(近七日)</label>'+
		  	'</div>'+
		  	'<select class="custom-select" id="prediction_afternoon_rain_selector">'+
		  		list_option_html +
			'</select>'+
		'</div>'+
		'<button type="button" class="btn btn-success btn-sm btn-block mt-2 function-log" function-log-id="4" id="prediction_afternoon_rain_trig">查詢</button>'+
		'<div id="prediction_afternoon_rain_prediction" class="mt-2"></div>' +
		'<div id="prediction_afternoon_rain_observation" class="mt-2"></div>'
	)
	$("#prediction_afternoon_rain_trig").click(function(){
		$("#map_clear").click()
		$("#legend_div_container").append('<div class="legend_text">午後雷陣雨實際發生區域<br><img src="legend/square_purple.png" width="32"></div>')
		render_block_spinner(['#prediction_afternoon_rain_prediction', '#prediction_afternoon_rain_observation'])
		var thisDate = $("#prediction_afternoon_rain_selector").val()
		ajax_call_async(publicPath + "/napi/simulate/watchncdr?query_date=" + thisDate, function(res){
			var html = { tbody: "", conclusion: "", mapcolor: "#E31A1C" }
			Object.keys(res.data).forEach(function(stationId){
				html.tbody += `<tr><td>${stationIdList[stationId]}</td>`
				timeList.forEach(function(eachTime){
					try {
						html.tbody += `<td>${res.data[stationId][eachTime].result}</td>`
					}
					catch(e){
						html.tbody += '<td>-</td>'
					}
				})
				html.tbody += '</tr>'
			})
			html.tbody += `<tr><td>合計</td><td>${res.conclusion["08"]}</td><td>${res.conclusion["09"]}</td><td>${res.conclusion["10"]}</td><td>${res.conclusion["11"]}</td></tr>`
			if (res.conclusion["11"] >= 7) {
				html.conclusion = "可能「會發生」午後雷陣雨"
			} else {
				var total = (res.conclusion["08"] +  res.conclusion["09"] + res.conclusion["10"] + res.conclusion["11"]) / 4
				if (total >= 7) {
					html.conclusion = "可能「會發生」午後雷陣雨"
				} else {
					html.conclusion = "可能「不會發生」午後雷陣雨"
					html.mapcolor = '#3ac569'
				}
			}
			overlay_dataset["ncdr_watch_prediction_layer"] = L.geoJson(overlay_dataset["Basic_map"], {
				style: function(feature){
					return { fillColor: html.mapcolor, weight: 0, opacity: 1, fillOpacity: 0.4 }
				},
				onEachFeature: function(feature, layer){
					layer.bindTooltip("預測結果：" + html.conclusion, {
						sticky: true,
						opacity: 1
					})
				}
			}).addTo(map)
			$("#prediction_afternoon_rain_prediction").html(`
				<hr class="mt-3 mb-3">
				<h5 class="font-weight-bold"><i class="far fa-chart-bar mr-2"></i>午後雷陣雨預測分析結果(${thisDate})</h5>
				<div class="card shadow-sm">
					<div class="card-body text-center">
						<h5 class="font-weight-bold m-0 text-danger">預測結果</h5>
						<hr class="m-2">
						${html.conclusion}
					</div>
				</div>
				<table class="table table-sm table-bordered text-center mt-3">
					<caption class="p-0">*註：此數字為評估指標，當指標滿足(1)上午11時指標達7項以上或(2) 8-11時指標權重平均達7以上條件，即達午後雷陣雨產生門檻。</caption>
					<thead class="thead-dark"><tr><th>測站</th><th>8點</th><th>9點</th><th>10點</th><th>11點</th></tr></thead>
					<tbody>${html.tbody}</tbody>
				</table>`
			)
			if (thisDate == todayIndex) { 
				backgroud_layer_control("閃電觀測")
				backgroud_layer_control("雷達強回波值")
			}
		})
		ajax_call_async(publicPath + "/napi/simulate/watchrainobs?query_date=" + thisDate, function(res){
			var html = { tbody: "", conclusion: "" }, timeSeriesList = ["12", "13", "14", "15", "16", "17"], regionObsList = {}, regionShowResult = {}
			res["result"].forEach(function(element){
				if (!regionShowResult[element.region]) {
					regionShowResult[element.region] = {}
				}
				regionShowResult[element.region][element.time] = true
			})
			Object.keys(res["rain"]).forEach(function(eachRegion){
				var stationLength = Object.keys(res["rain"][eachRegion]).length, thisRegionRow = ""
				if (regionShowResult[eachRegion]) {
					Object.keys(res["rain"][eachRegion]).forEach(function(eachStation, index){
						if (index == 0) {
							thisRegionRow += `<tr town-name="${eachRegion}"><td rowspan="${stationLength}">${eachRegion.replace("區", "")}</td>`		
						} else {
							thisRegionRow += `<tr town-name="${eachRegion}">`
						}
						thisRegionRow += `<td>${eachStation}</td>`
						timeSeriesList.forEach(function(eachTime){
							if (res["rain"][eachRegion][eachStation][eachTime]) {
								var thisRainValue = rain_value_processing(res["rain"][eachRegion][eachStation][eachTime])
								if (regionShowResult[eachRegion][eachTime]) {
									thisRegionRow += `<td class="bg-danger text-white">${thisRainValue}</td>`
								} else {
									thisRegionRow += `<td>${thisRainValue}</td>`
								}
							} else {
								thisRegionRow += '<td>-</td>'
							}
						})
						// result
						if (index == 0) {
							thisRegionRow += `<td rowspan="${stationLength}">發生</td></tr>`
						}
					})
					html.tbody += thisRegionRow
				}
			})
			if (html.tbody == "") {
				html.conclusion = '沒有區域發生午後雷陣雨'
				html.tbody = '<tr><td colspan="9">沒有區域發生午後雷陣雨</tr></td>'
			} else {
				var regionListHtml = "", regionListArray = Object.keys(regionShowResult)
				if (regionListArray.length == 1) {
					regionListHtml = regionListArray[0]
				} else {
					regionListArray.forEach(function(each, index){
						if ((regionListArray.length - 1) == index) {
							regionListHtml += each
						} else {
							regionListHtml += each + "、"
						}
					})
				}
				html.conclusion = '共有「' + regionListArray.length + '區」發生午後雷陣雨，<br>區域為' + regionListHtml
			}
			setTimeout(function(){
				overlay_dataset["ncdr_watch_observation_layer"] = L.geoJson(overlay_dataset["Basic_map"], {
					style: function(feature) {
						return { color: "purple", weight: 3, fill: false }
					},
					filter: function(feature) {
						var bool = Object.keys(regionShowResult).includes(feature.properties.TOWNNAME)
						return (bool == true)
					},
					onEachFeature: function(feature, layer){
						layer.bindTooltip("「" + feature.properties.TOWNNAME + "」實際發生午後雷陣雨", {
							sticky: true,
							opacity: 1
						})
					}
				}).addTo(map)
			}, 2000)
			$("#prediction_afternoon_rain_observation").html(`
				<hr class="mt-3 mb-3">
				<h5 class="font-weight-bold"><i class="fas fa-table mr-2"></i>當日午後雷陣雨觀測統計</h5>
				<div class="card shadow-sm">
					<div class="card-body text-center">
						<h5 class="font-weight-bold m-0 text-danger">觀測結果</h5>
						<hr class="m-2">
						<p class="pl-3 pr-3 m-0">${html.conclusion}</p>
					</div>
				</div>
				<table class="table table-sm table-bordered text-center mt-3 table-pointer table-zoom-town-region">
					<caption class="p-0">*註：本系統判斷區域發生午後雷陣雨(該區域觀測時間若發生，表格以<i class="fas fa-square text-danger mr-1 ml-1"></i>標示。)，須符合兩種條件(1)該區域發生午後降雨且有發生短延時強降雨(10分鐘雨量達10mm以上)、(2)該區域有強回波與閃電觀測發生。</caption>
					<thead class="thead-dark"><tr><th rowspan="2">區域</th><th rowspan="2">站名</th><th colspan="6">觀測時間</th><th rowspan="2">結果</th></tr><tr><th>12</th><th>13</th><th>14</th><th>15</th><th>16</th><th>17</th></tr></thead>
					<tbody>${html.tbody}</tbody>
				</table>`
			)
		})
	})
}
